import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import ConfigAPI from '@/config/api'
import Session from '@/handler/session'

Vue.use(VueAxios, axios)

const instance = axios.create();

// ─── Caché en memoria ─────────────────────────────────────────────────────────
// Desactivado por defecto. Solo salesCounter llama enableDetailCache().
// Todos los demás módulos funcionan exactamente igual que antes.
let _cacheActive = false

const _cache = {
  searches:     new Map(),
  products:     new Map(),
  prices:       new Map(),
  equivalences: new Map(),
}

// Requests en vuelo — evita duplicados si el mismo recurso se pide dos veces
// antes de que llegue la primera respuesta
const _inflight = {
  searches:     new Map(),
  products:     new Map(),
  prices:       new Map(),
}


export function enableDetailCache()  { _cacheActive = true  }
export function disableDetailCache() { _cacheActive = false }
export function clearDetailCache() {
  _cache.searches.clear()
  _cache.products.clear()
  _cache.prices.clear()
  _cache.equivalences.clear()
  _inflight.searches.clear()
  _inflight.products.clear()
  _inflight.prices.clear()
}
// ─────────────────────────────────────────────────────────────────────────────

const servicesAPI = {

  obtenerPrecioProducto(data) {
    if (_cacheActive) {
      const key = `${data.product ? data.product.id : ''}|${data.customer_id}|${data.price_list_id}|${data.reason_id || 0}|${data.disable_customer_price_list_fallback ? 1 : 0}`
      const hit = _cache.prices.get(key)
      if (hit) return Promise.resolve({ data: hit.data })
      if (_inflight.prices.has(key)) return _inflight.prices.get(key)
      var url = ConfigAPI.baseURL + "products/get/price" + Session.getToken();
      const req = instance.post(url, data)
        .then(res => { _cache.prices.set(key, { data: res.data }); _inflight.prices.delete(key); return res })
        .catch(err => { _inflight.prices.delete(key); throw err })
      _inflight.prices.set(key, req)
      return req
    }
    var params = data
    var url = ConfigAPI.baseURL + "products/get/price" + Session.getToken();
    return instance.post(url,params);
  },

  obtenerPrecioServicio(data) {
    var params = data
    var url = ConfigAPI.baseURL + "services/get/price" + Session.getToken();
    return instance.post(url,params);
  },

  obtenerPrecioProductoCompuesto(data) {
    var params = data
    var url = ConfigAPI.baseURL + "products-compound/get/price" + Session.getToken();
    return instance.post(url,params);
  },

  obtenerEquivalencesAvailable(data) {
    if (_cacheActive) {
      const key = String(data.unit_measurement_id)
      const hit = _cache.equivalences.get(key)
      if (hit) return Promise.resolve({ data: hit.data })
      var url = ConfigAPI.baseURL + "products-unit-measurement/filter/equivalenceAvailable" + Session.getToken();
      return instance.post(url, data)
        .then(res => { _cache.equivalences.set(key, { data: res.data }); return res })
    }
    var params = data
    var url = ConfigAPI.baseURL + "products-unit-measurement/filter/equivalenceAvailable" + Session.getToken();
    return instance.post(url,params);
  },
  recalculePriceByUnitMeasurementAlternative(data) {
    var params = data
    var url = ConfigAPI.baseURL + "products-unit-measurement/recalcule/price" + Session.getToken();
    return instance.post(url,params);
  },

  obtenerProductos(data) {
    if (_cacheActive) {
      const key = `${data.filter || ''}|${data.price_list_id || 0}|${JSON.stringify(data.where || [])}`
      const hit = _cache.searches.get(key)
      if (hit) return Promise.resolve({ data: hit.data })
      if (_inflight.searches.has(key)) return _inflight.searches.get(key)
      var url = ConfigAPI.baseURL + "products/find/control/controlByFilter" + Session.getToken();
      const req = instance.post(url, data)
        .then(res => { _cache.searches.set(key, { data: res.data }); _inflight.searches.delete(key); return res })
        .catch(err => { _inflight.searches.delete(key); throw err })
      _inflight.searches.set(key, req)
      return req
    }
    var params = data
    var url = ConfigAPI.baseURL + "products/find/control/controlByFilter" + Session.getToken();
    return instance.post(url,params);
  },
  mostrarProducto(id, data) {
    if (_cacheActive) {
      const key = `${id}|${JSON.stringify(data && data.where || [])}`
      const hit = _cache.products.get(key)
      if (hit) return Promise.resolve({ data: hit.data })
      if (_inflight.products.has(key)) return _inflight.products.get(key)
      var url = ConfigAPI.baseURL + "products/find/control/controlShow/" + id + Session.getToken();
      const req = instance.post(url, data)
        .then(res => { _cache.products.set(key, { data: res.data }); _inflight.products.delete(key); return res })
        .catch(err => { _inflight.products.delete(key); throw err })
      _inflight.products.set(key, req)
      return req
    }
    var params = data
    var url = ConfigAPI.baseURL + "products/find/control/controlShow/" + id + Session.getToken();
    return instance.post(url,params);
  },


  obtenerConfiguracion() {
    var url = ConfigAPI.baseURL + "sales-configuration" + Session.getToken();
    return instance.get(url);
  },
  saveConfiguracion(data) {
    var params = data
    var url = ConfigAPI.baseURL + "sales-configuration/" + data.id + Session.getToken();
    return instance.post(url,params);
  },
}

export default servicesAPI;
